import { Action, createReducer, on } from '@ngrx/store';
import { Feature, Point } from 'geojson';
import { setResults } from './results.actions';

export const featureKey = 'results';

export type Result = Feature<
  Point,
  {
    name: string;
  }
>;
export interface State {
  /* results: Result[];
  resultsByID: Map<number, Result>; */
  results: any[];
  resultsByID: Map<any, any>;
  selectedResultID: number | null;
}

const initialState: State = {
  results: [],
  resultsByID: new Map(),
  selectedResultID: null,
};

export const resultsReducer = createReducer(
  initialState,
  on(setResults, (state, { results }) => ({
    ...state,
    resultsByID: new Map(results.map((result) => [result.id, result])),
    results,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return resultsReducer(state, action);
}
